export default {
    apiUrl:{
        couponManagement:{
            //创建优惠券
            addCoupon:'/promotion/coupon/addPromotionPlatformCoupon',
            //优惠券管理列表
            getCouponList:'/promotion/mgmt/getCouponsList',
            //编辑优惠券
            editCoupon:'/promotion/mgmt/findPromotionById',
            //删除
            cancel:'/promotion/coupon/cancelPlatformCoupon',
            //日志查看
            checkJournal:'promotion/mgmt/getPromotionLogLists',
            //获取店铺选中信息
            getCouponStoreInfos:'/promotion/coupon/getCouponStores',
            //获取店铺列表
            getStoreInfosList:'/merchant/storeInfo/getStoreInfosList',
            //保存店铺
            addStore:'/promotion/coupon/insertPlatformCouponStores',
            //取消选择店铺
            cancelCouponStore:'/promotion/coupon/cancelCouponStore',
            //发布接口
            releaseCoupon:'/promotion/coupon/releasePlatformCoupon',
            //发布中的保存编辑
            saveRelease:'/promotion/coupon/save',
            //复制优惠券
            copyCoupon:'/promotion/coupon/copyPlatformCoupon',
            //选择优惠券
            chooseCouponlist:'/promotion/CouponActivity/getCouponList',
            //保存选择优惠券
            saveSelectedCoupons:'/promotion/CouponActivity/saveSelectedCoupons',
            //获取选中的优惠券
            getSelectedCoupons:'/promotion/CouponActivity/getSelectedCoupons',
            //取消选中的优惠券
            cancelChoose:'/promotion/CouponActivity/cancelCoupon',
            //新优惠券的保存发布
            saveAcitivity:'/promotion/CouponActivity/saveAcitivity',
            //取消新增
            cancelAdd:'/promotion/CouponActivity/cancel',

            // 优惠券圈商品接口
            saveItems:'/promotion/coupon/platform/template/saveItems/',//新增商品
            removeItems:'/promotion/coupon/platform/template/removeItems/',//新增商品
            getItemList:'/promotion/coupon/platform/template/getItemList/',//新增商品
            platformItems:'/goods/item/platformItems',//查询平台所有上架商品（左选右的左）
            getAllItemList:'/promotion/coupon/platform/template/getAllItemList',//（左选右的右）

            //新增优惠券模板基本信息
            saveBasic:'/promotion/coupon/platform/template/addBasic',
            //编辑优惠券模板基本信息
            editBasic:'/promotion/coupon/platform/template/editBasic',
            //获取优惠券编辑详情
            getBasic:'/promotion/coupon/platform/template/getBasic',
            //圈店铺步骤的优惠券提交审核
            submitGrantAudit:'/promotion/coupon/platform/templateAudit/submitGrantAudit',
            //优惠券发行列表
            getList:'/promotion/coupon/platform/template/getList',
            //优惠券发行详情
            getDetail:'/promotion/coupon/platform/template/getDetail',
            //被圈定店铺的列表
            getStoreCheckedList:'/promotion/coupon/platform/template/getStoreList',
            //圈定店铺
            saveStore:'/promotion/coupon/platform/template/saveStores',
            //删除圈定的店铺
            deleteStore:'/promotion/coupon/platform/template/removeStores',
            //审核列表
            getAuditList:'/promotion/coupon/platform/templateAudit/getList',
            //审核详情
            getAuditDetail:'/promotion/coupon/platform/templateAudit/getDetail',
            //审核通过
            auditPass:'/promotion/coupon/platform/templateAudit/pass',
            //审核驳回
            auditReject:'/promotion/coupon/platform/templateAudit/reject',
            //增发
            submitSupplyAudit:'/promotion/coupon/platform/templateAudit/submitSupplyAudit',
            //全部店铺列表
            getAllStoreList:'/promotion/coupon/platform/template/getAllStoreList',
            //停止发布
            stopGrant:'/promotion/coupon/platform/template/stopGrant',
            //复制优惠券模板
            copyTemplate:'/promotion/coupon/platform/template/copyTemplate',
            //删除优惠券模板
            removeTemplate:'/promotion/coupon/platform/template/removeTemplate',
            //优惠券信息管理列表
            getInfoList:'/promotion/coupon/platform/info/getList ',
            //优惠券信息详情
            getInfoDetail:'/promotion/coupon/platform/info/getDetail',
            //日志列表
            getLogList:'/promotion/coupon/platform/template/getLogList',
            //冻结优惠券
            freezeCoupon:'/promotion/coupon/platform/info/freezeCoupon',
            //解冻优惠券
            unfreezeCoupon:'/promotion/coupon/platform/info/unfreezeCoupon',
            //批量冻结优惠券
            batchFreeze:'/promotion/coupon/platform/info/batchFreeze'
        },
        couponTool:{
            list:'/promotion/autoGrant/coupon/list',/* 查询活动列表 */
            addPromotionId:'/promotion/autoGrant/coupon/addPromotionId',/* 创建活动 */
            save_release:'/promotion/autoGrant/coupon/save_release',/* 保存或者发布活动 */
            deletePromotion:'/promotion/autoGrant/coupon/delete/',
            findOne:'/promotion/autoGrant/coupon/findOne/',/* 查看活动详情 */
            download:'/promotion/autoGrant/coupon/download/',/* 下载成功或者失败记录 */
            findLogs:'/promotion/autoGrant/coupon/findLogs/',/* 操作日志 */
        }
    }
}
